import type { Meta, StoryObj } from "@storybook/react";

import type { AdditionalHelpfulInfoProps } from "@/ui/components/profile/safetyPlan/AdditionalHelpfulInfo";
import AdditionalHelpfulInfo from "@/ui/components/profile/safetyPlan/AdditionalHelpfulInfo";
import ScreenContainer from "@/ui/layout/ScreenContainer";

const StoryMeta: Meta<AdditionalHelpfulInfoProps> = {
  title: "Components/Safety Plan/Additional Info",
  component: AdditionalHelpfulInfo,
  render: () => (
    <ScreenContainer isScrollView>
      <AdditionalHelpfulInfo selectedUserId="storybook" />
    </ScreenContainer>
  ),
};

type Story = StoryObj<AdditionalHelpfulInfoProps>;

const Primary: Story = {};

export { Primary };
export default StoryMeta;
